// custom typefaces
import "@fontsource/tajawal";
import "@openfonts/tajawal_arabic";

export const onInitialClientRender = () => {
  window.___MNEMONIC_INITIAL_RENDER_COMPLETE = true;
};

export { wrapPageElement } from "./src/context/locale-context";
